// extracted by mini-css-extract-plugin
export default {"Paper":"Paper_Paper__04aVu","LightPaper":"Paper_LightPaper__Bf14V","DarkPaper":"Paper_DarkPaper__I6jDc"};